import { render, staticRenderFns } from "./RangeDates.vue?vue&type=template&id=65368741&scoped=true&lang=pug"
import script from "./RangeDates.vue?vue&type=script&lang=js"
export * from "./RangeDates.vue?vue&type=script&lang=js"
import style0 from "./RangeDates.vue?vue&type=style&index=0&id=65368741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65368741",
  null
  
)

export default component.exports